module.exports = __webpack_public_path__ + "img/2-3-2.b302e43a.png";